import React, { useState, useRef } from 'react';
import { View, Text, StyleSheet } from 'react-native';
import ReactDOM from 'react-dom';

const TooltipWrapper = ({ overlay, children, tooltipWidth = 360 }) => {
  const [visible, setVisible] = useState(false);
  const [position, setPosition] = useState({ top: 0, left: 0 });
  const triggerRef = useRef(null);

  const handleMouseEnter = () => {
    if (triggerRef.current) {
      const rect = triggerRef.current.getBoundingClientRect();
      setPosition({
        top: rect.bottom + 8,
        left: rect.left + rect.width / 2 - tooltipWidth / 2
      });
    }
    setVisible(true);
  };

  const handleMouseLeave = () => {
    setVisible(false);
  };

  return (
    <>
      <View
        ref={triggerRef}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        style={{ position: 'relative' }}
      >
        {children}
      </View>

      {visible &&
        ReactDOM.createPortal(
          <View
            style={[
              styles.tooltipContainer,
              {
                width: tooltipWidth,
                top: position.top,
                left: position.left
              }
            ]}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            <View style={styles.tooltipArrow} />
            <Text style={styles.tooltipText}>{overlay}</Text>
          </View>,
          document.body
        )}
    </>
  );
};

const styles = StyleSheet.create({
  tooltipContainer: {
    position: 'fixed',
    backgroundColor: '#F5F5F5',
    borderRadius: 12,
    paddingVertical: 14,
    paddingHorizontal: 16,
    borderWidth: 1,
    borderColor: '#E1E4E8',
    zIndex: 9999,
    elevation: 50,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.15,
    shadowRadius: 8,
    pointerEvents: 'auto',
  },
  tooltipArrow: {
    position: 'fixed',
    top: -8,
    left: '50%',
    marginLeft: -8,
    width: 0,
    height: 0,
    borderLeftWidth: 8,
    borderRightWidth: 8,
    borderBottomWidth: 10,
    borderStyle: 'solid',
    borderLeftColor: 'transparent',
    borderRightColor: 'transparent',
    borderBottomColor: '#F5F5F5',
  },
  tooltipText: {
    color: '#1A1A1A',
    fontSize: 15,
    lineHeight: 22,
    textAlign: 'left',
  },
});

export default TooltipWrapper;
